import { createReduxAsyncThunk } from 'shared/utils';
import { saveAs } from 'file-saver';
import { stationsAPI } from 'entities/stations';
import { parseContentDisposition } from 'shared/utils';

import { STATIONS_STATE } from '../../constants';

import { AxiosResponse } from 'axios';
import { DownloadStationsPricesReportFilter } from 'entities/stations';

export const downloadStationsPriceReport = createReduxAsyncThunk<AxiosResponse<Blob>, DownloadStationsPricesReportFilter>(
  `${STATIONS_STATE}/downloadStationsPriceReport`,
  async (filter) => {
    const response = await stationsAPI.downloadStationsPriceReport(filter);
    const { filename } = parseContentDisposition(response.headers['content-disposition']) || {} as any;
    saveAs(response.data, filename);

    return response;
  }
);
